import routes from 'app/team/routes';

export default {
  reducers: {},
  actionTypes: {},
  routes,
};
